.app {
  min-height: 100svh;
  overflow: clip;
  background: var(--color-background);
}
